module.exports = __webpack_public_path__ + "static/media/mode-67.a098466c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Containers/Workspace/Tools/GgbIcons/mode-67.svg
// module id = 1020
// module chunks = 2